import {
  Box,
  Collapse,
  Grid,
  IconButton,
  Paper,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Theme,
  Typography,
  useMediaQuery,
} from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import React, { useEffect, useState } from 'react'
import { Gender, Member, MemberResponse, RelationResponse, User, UserRole } from '../../../shared/types'
import { useSelector } from 'react-redux'
import { getMembers, getRelations } from '../../../store/data/data.selectors'
import FemaleIcon from '@mui/icons-material/Female'
import MaleIcon from '@mui/icons-material/Male'
import { makeStyles } from '@mui/styles'
import getDateStringFromCustomDate from '../../../util/getDateStringFromCustomDate'
import DropDownComponent from '../../../shared/components/DropDownComponent'
import SearchInput from '../../../shared/components/SearchInput'
import { FamilyType } from '../../../screens/App/FamilyMember/FamilyTree/types'
import getAgeFromMember from '../../../util/getAgeFromMember'
import DateAndPlace, { DateAndPlaceType } from '../../../screens/App/FamilyMember/FamilyTree/Templates/DateAndPlace'
import { getAppTheme } from '../../../shared/config/getAppTheme'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { getSearchInput, getUser } from '../../../store/settings/settings.selectors'
import Env from '../../../shared/config/envConfig'
import { getApiVersion } from '../../../shared/config/getApiVersion'

const useStyles = makeStyles((theme: Theme) => ({
  tableHeader: {
    fontWeight: 'bold',
    textAlign: 'left',
  },
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexWrap: 'nowrap',
  },
  content: {
    width: '50%',
  },
}))

export enum LivingState {
  alive = 'alive',
  dead = 'dead',
}

export enum Aging {
  child = 'child',
  adult = 'adult',
}

const FamilyMemberTable: React.FC = () => {
  const theme: Theme = getAppTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))
  const downMd = useMediaQuery(theme.breakpoints.down('md'))

  const user: User | undefined = useSelector(getUser)
  const searchResult: string | undefined = useSelector(getSearchInput)
  const members: MemberResponse | undefined = useSelector(getMembers)
  const relations: RelationResponse | undefined = useSelector(getRelations)
  const classes = useStyles()

  const [filteredMembers, setFilteredMembers] = useState<Member[]>(members?.results || [])
  const [pagedFilteredMembers, setPagedFilteredMembers] = useState<Member[]>(members?.results || [])

  const [search, setSearch] = useState<string | undefined>()
  const [family, setFamily] = useState<FamilyType | undefined>()
  const [gender, setGender] = useState<Gender | undefined>()
  const [livingState, setLivingState] = useState<LivingState | undefined>()
  const [aging, setAgeing] = useState<Aging | undefined>()

  const [orderBy, setOrderBy] = useState<'firstname' | 'lastname'>('lastname')
  const [order, setOrder] = useState<'asc' | 'desc'>('asc')
  // const [openTree, setOpenTree] = useState<string | undefined>()
  const [page, setPage] = useState<number>(0)
  const [pageSize, setPageSize] = useState<number>(25)

  const [open, setOpen] = useState<string | null>(null)

  const memberTermArray = [
    'city', 'zip', 'lastname', 'firstname', 'address', 'birthname', 'country', 'dietType', 'email', 'gender', 'middlenames', 'nickname', 'gender', 'phone', 'placeOfBirth', 'placeOfDeath', 'title']

  const filterMember = () => {
    let newFilteredMembers: Member[] = members?.results || []
    // nach Geschlecht filtern
    if (gender) {
      newFilteredMembers = newFilteredMembers.filter(elem => elem.gender === gender)
    }
    // nach Familie filtern
    if (family) {
      newFilteredMembers = newFilteredMembers.filter(elem => relations?.results.find(rel => rel.id === elem.id)?.family === family)
    }
    // nach lebendig filtern
    if (livingState && livingState === LivingState.dead) {
      newFilteredMembers = newFilteredMembers.filter(elem => elem.dead)
    }
    // nach tot filtern
    if (livingState && livingState === LivingState.alive) {
      newFilteredMembers = newFilteredMembers.filter(elem => !elem.dead)
    }
    // nach Kindern filtern
    if (aging && aging === Aging.child) {
      newFilteredMembers = newFilteredMembers.filter(elem => getAgeFromMember(elem) && getAgeFromMember(elem)! < 18)
    }
    // nach Erachsenen filtern
    if (aging && aging === Aging.adult) {
      newFilteredMembers = newFilteredMembers.filter(elem => getAgeFromMember(elem) && getAgeFromMember(elem)! >= 18)
    }

    // Suchfeld einbeziehen
    const searchResultArray: string[] | undefined = search?.split(' ')
    const regExArray: RegExp[] = []
    searchResultArray?.map(elem => {
      elem && regExArray.push(new RegExp(elem.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss'), 'gim'))
    })
    type tempSearchResult = {
      [key: number]: Member[]
    }
    if (regExArray.length > 0) {
      const temp: tempSearchResult = {}
      regExArray.map((regEx, index) => {
        temp[index] = []
        newFilteredMembers.map((member: Member) => {
          memberTermArray.map((term: string) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (member[term] && member[term]?.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss').search(regEx) > -1) {
              if (!temp[index].find(elem => elem.id === member.id)) {
                temp[index].push(member)
              }
            }
          })
        })
      })
      // AND Verknüfung aller Suchergebnisse
      temp[0].map((element, index) => {
        for (let n = 1; n < Object.keys(temp).length; n += 1) {
          if (!temp[n].find(reference => JSON.stringify(reference) === JSON.stringify(element))) {
            delete temp[0][index]
          }
        }
      })

      newFilteredMembers = temp[0]
    }

    // sortieren
    newFilteredMembers.sort((a, b) => {
      const nameA = a[orderBy].toUpperCase()
      const nameB = b[orderBy].toUpperCase()
      if (order === 'asc') {
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }
        return 0
      } else {
        if (nameA > nameB) {
          return -1
        }
        if (nameA < nameB) {
          return 1
        }
        return 0
      }
    })

    // Paging integrieren
    setPagedFilteredMembers(newFilteredMembers.slice(page * pageSize, (page * pageSize) + pageSize))
    // zurück schreiben
    setFilteredMembers(newFilteredMembers)
  }

  useEffect(() => {
    setFilteredMembers(members?.results || [])
  }, [members])

  useEffect(() => {
    filterMember()
  }, [search, family, gender, page, pageSize, orderBy, order, livingState, aging])

  useEffect(() => {
    setSearch(searchResult)
  }, [searchResult])

  const getMember = (id?: string) => {
    if (id) {
      return members?.results.find(item => item.id === id)
    }
  }

  // neuen Nutzer anlegen / Email mit Zugansdaten versenden
  const sendMailToUser = (member: Member) => {
    const restPath = Env.restBase
    const requestHeaders: HeadersInit = new Headers()
    requestHeaders.set('Accept', 'application/json')
    requestHeaders.set('Content-Type', 'application/json')
    const restUrl = `${restPath}/api/${getApiVersion()}/user/passwordmail`
    fetch(restUrl,
      {
        method: 'POST',
        body: JSON.stringify(
          {
            memberId: member.originId,
          }),
        credentials: 'include',
        headers: requestHeaders,
      })
      .then(res => res.json())
      .then((json) => {
        console.log(json)
      })
      .catch(err => console.log(err))
  }

  const Row = (member: Member) => {
    const node = relations?.results.find(elem => elem.id === member.id)
    return (
      <>
        <TableRow key={member.id}>
          {!downMd &&
            <TableCell>
              {member.showDetails &&
                <IconButton
                  size='small'
                  onClick={() => (open && open === member.id) ? setOpen(null) : setOpen(member.id ? member.id : null)}
                >
                  {(open && open === member.id) ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>}
            </TableCell>}
          <TableCell>
            {`${member.firstname} ${member.showDetails && member.middlenames ? member.middlenames : ''}`}
          </TableCell>
          <TableCell>
            {`${member.lastname} ${member.birthname && member.showDetails ? `(geb. ${member.birthname})` : ''}`}
          </TableCell>
          {!downMd &&
            <TableCell>
              {member.showDetails && `${getDateStringFromCustomDate(member.birthday)} ${member.placeOfBirth ? `in ${member.placeOfBirth}` : ''}`}
            </TableCell>}
          {!downMd &&
            <TableCell>
              {member.showDetails && `${getDateStringFromCustomDate(member.deathday)} ${member.placeOfDeath ? `in ${member.placeOfDeath}` : ''}`}
            </TableCell>}
          <TableCell>
            {member.gender === Gender.male
              ? <MaleIcon />
              : <FemaleIcon />}
          </TableCell>
          {user && user.userRole === UserRole.admin &&
            <TableCell>
              {member.email &&
                <IconButton onClick={() => sendMailToUser(member)}>
                  <MailOutlineIcon />
                </IconButton>}
            </TableCell>}
        </TableRow>
        <TableRow>
          {!downMd &&
            <TableCell
              style={{ paddingBottom: 0, paddingTop: 0 }}
              colSpan={user && user.userRole === UserRole.admin ? 7 : 6}
            >
              <Collapse in={!!(open && open === member.id)} timeout='auto' unmountOnExit>
                <Box sx={{ margin: 1 }}>
                  <Typography variant='h6' gutterBottom component='div'>
                    Daten
                  </Typography>
                  <Grid container width='100%'>
                    <Grid item xs={8}>
                      {member?.showDetails &&
                        <Box>
                          <Typography>
                            <DateAndPlace
                              date={member?.birthday}
                              place={member?.placeOfBirth}
                              type={DateAndPlaceType.birth}
                            />
                          </Typography>
                          <Typography>
                            <DateAndPlace
                              date={member?.deathday}
                              place={member?.placeOfDeath}
                              type={DateAndPlaceType.death}
                            />
                          </Typography>
                        </Box>}
                      <Box className={classes.container}>
                        {node?.parents && node?.parents.length > 0 &&
                          <Box className={classes.content}>
                            <Typography><b>Eltern</b></Typography>
                            <Typography>
                              {node?.parents[0] && `${getMember(node?.parents[0].id)?.firstname} ${getMember(node?.parents[0].id)?.lastname}`}
                            </Typography>
                            <Typography>
                              {node?.parents[1] && `${getMember(node?.parents[1].id)?.firstname} ${getMember(node?.parents[1].id)?.lastname}`}
                            </Typography>
                          </Box>}
                        {node?.spouses && node?.spouses.length > 0 &&
                          <Box className={classes.content}>
                            <Typography><b>Partner</b></Typography>
                            {node?.spouses.map((spouse, index) =>
                              <Typography key={index}>
                                {`${getMember(spouse.id)?.firstname} ${getMember(spouse.id)?.lastname}`}
                              </Typography>
                            )}
                          </Box>}
                      </Box>
                      <Box className={classes.container}>
                        {node?.siblings && node?.siblings.length > 0 &&
                          <Box className={classes.content}>
                            <Typography><b>Geschwister</b></Typography>
                            {node?.siblings.map((sibling, index) =>
                              <Typography key={index}>
                                {`${getMember(sibling.id)?.firstname} ${getMember(sibling.id)?.lastname}`}
                              </Typography>
                            )}
                          </Box>}
                        {node?.children && node?.children.length > 0 &&
                          <Box className={classes.content}>
                            <Typography><b>Kinder</b></Typography>
                            {node?.children.map((child, index) =>
                              <Typography key={index}>
                                {`${getMember(child.id)?.firstname} ${getMember(child.id)?.lastname}`}
                              </Typography>
                            )}
                          </Box>}
                      </Box>
                    </Grid>
                    <Grid item xs={4} textAlign='right'>
                      <img
                        style={{ width: 'auto', height: '200px', margin: '10px 0' }}
                        alt={`${member?.firstname} ${member?.middlenames ? member?.middlenames : ''} ${member?.lastname}`}
                        src={member?.profileImageUrl ? member?.profileImageUrl : `/profileImages/${member?.id}.jpg`}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Collapse>
            </TableCell>}
        </TableRow>
      </>
    )
  }

  const FilterTemplate = () => {
    return (
      <>
        <Grid item xs={downMd ? 12 : 4}>
          <DropDownComponent
            size='small'
            value={family}
            options={[
              { key: FamilyType.IlseKaiser, value: 'Ilse Kaiser' },
              { key: FamilyType.HeinzMichael, value: 'Heinz Michael' },
              { key: FamilyType.JuergenKuther, value: 'Jürgen Kuther' },
              { key: FamilyType.ThomasKuther, value: 'Thomas Kuther' },
              { key: FamilyType.AndreasKuther, value: 'Andreas Kuther' },
              { key: FamilyType.HeikeKuther, value: 'Heike Kuther' },
            ]}
            label='Familie'
            onChange={(value) => {
              setPage(0)
              value ? setFamily(value.key as FamilyType) : setFamily(undefined)
            }}
          />
        </Grid>
        <Grid item xs={downMd ? 12 : 4}>
          <DropDownComponent
            size='small'
            value={gender}
            options={[{ key: Gender.male, value: 'männlich' }, { key: Gender.female, value: 'weiblich' }]}
            label='Geschlecht'
            onChange={(value) => {
              setPage(0)
              value ? setGender(value.key as Gender) : setGender(undefined)
            }}
          />
        </Grid>
        <Grid item xs={downMd ? 12 : 4}>
          <DropDownComponent
            size='small'
            value={livingState}
            options={[
              { key: LivingState.alive, value: 'lebendig' },
              { key: LivingState.dead, value: 'verstorben' },
            ]}
            label='Status'
            onChange={(value) => {
              setPage(0)
              value ? setLivingState(value.key as LivingState) : setLivingState(undefined)
            }}
          />
        </Grid>
        <Grid item xs={downMd ? 12 : 4}>
          <DropDownComponent
            size='small'
            value={aging}
            options={[
              { key: Aging.child, value: 'Kinder' },
              { key: Aging.adult, value: 'Erwachsene' },
            ]}
            label='Alter'
            onChange={(value) => {
              setPage(0)
              value ? setAgeing(value.key as Aging) : setAgeing(undefined)
            }}
          />
        </Grid>
      </>
    )
  }

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const openFilter = Boolean(anchorEl)

  return (
    <Paper sx={{ margin: downSm ? '0px' : '32px', padding: downSm ? '8px' : '32px' }}>
      <Typography variant='h1'>Liste der Familienmitglieder</Typography>
      <Grid container spacing={2} sx={{ width: '100%' }}>
        <Grid
          item xs={downMd ? 12 : 4} spacing={2}
          sx={downMd ? {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          } : {}}
        >
          <SearchInput
            value={search}
            onChangeValue={(value) => {
              setPage(0)
              value ? setSearch(value) : setSearch(undefined)
            }}
          />
          {downMd &&
            <>
              <Box sx={{ position: 'relative', marginLeft: '10px' }}>
                <Box
                  sx={{ border: `1px solid ${theme.palette.grey['400']}`, width: '42px', borderRadius: '4px' }}
                >
                  <IconButton onClick={handleClick}>
                    <FilterAltIcon />
                  </IconButton>
                </Box>
                <Box
                  sx={(gender || family || livingState || aging) ? {
                    borderRadius: '10px',
                    width: '15px',
                    height: '15px',
                    backgroundColor: theme.palette.primary.dark,
                    color: '#fff',
                    position: 'absolute',
                    top: '-5px',
                    right: '-5px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  } : {
                    width: '15px',
                    height: '15px',
                    top: '-5px',
                    right: '-5px',
                    position: 'absolute',
                    color: 'transparent',
                  }}
                >
                  !
                </Box>
              </Box>
              <Popover
                open={openFilter}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
              >
                <Box
                  sx={{ padding: '20px' }}
                >
                  {FilterTemplate()}
                  <Box
                    sx={{ color: theme.palette.primary.main, textAlign: 'center' }}
                    onClick={() => {
                      setFamily(undefined)
                      setGender(undefined)
                      setLivingState(undefined)
                      setAgeing(undefined)
                      handleClose()
                    }}
                  >
                    <Typography variant='body1' sx={{ cursor: 'pointer' }}>Alle Filter
                      entfernen
                    </Typography>
                  </Box>
                </Box>
              </Popover>
            </>}
        </Grid>
        {!downMd && FilterTemplate()}
      </Grid>
      <Table size='small' sx={{ marginTop: '20px' }}>
        <TableHead>
          <TableRow>
            {!downMd &&
              <TableCell className={classes.tableHeader}>
                &nbsp;
              </TableCell>}
            <TableCell className={classes.tableHeader}>
              <TableSortLabel
                color='primary'
                active={orderBy === 'firstname'}
                direction={order}
                className={classes.tableHeader}
                key='firstname'
                onClick={() => {
                  setOrderBy('firstname')
                  setOrder(order === 'asc' ? 'desc' : 'asc')
                }}
              >Vorname
              </TableSortLabel>
            </TableCell>
            <TableCell className={classes.tableHeader}>
              <TableSortLabel
                color='primary'
                active={orderBy === 'lastname'}
                direction={order}
                className={classes.tableHeader}
                key='lastname'
                onClick={() => {
                  setOrderBy('lastname')
                  setOrder(order === 'asc' ? 'desc' : 'asc')
                }}
              >Nachname
              </TableSortLabel>
            </TableCell>
            {!downMd &&
              <TableCell className={classes.tableHeader}>
                geboren
              </TableCell>}
            {!downMd &&
              <TableCell className={classes.tableHeader}>
                gestorben
              </TableCell>}
            <TableCell className={classes.tableHeader}>
              &nbsp;
            </TableCell>
            {user && user.userRole === UserRole.admin &&
              <TableCell className={classes.tableHeader}>
                &nbsp;
              </TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {pagedFilteredMembers.map((member: Member) =>
            Row(member),
          )}
        </TableBody>
        <TablePagination
          count={filteredMembers.length}
          page={page}
          rowsPerPage={pageSize}
          rowsPerPageOptions={downSm ? [] : [10, 25, 50, 100]}
          onPageChange={(event, page) => setPage(page)}
          onRowsPerPageChange={(pageSize) => {
            setPage(0)
            setPageSize(parseInt(pageSize.target.value, 10))
          }}
        />
      </Table>
    </Paper>
  )
}

export default FamilyMemberTable
